import React from 'react';

const SupportModeContext = React.createContext(false);
export const SupportModeContextProvider = SupportModeContext.Provider;
export default SupportModeContext;